import { ApiClient } from "spry-react/utils/apiClient";
import { FetchesAddressSuggestions } from "spry-react/Address/addressSuggestion";
import { AddressSuggestionsCommand } from "shared/Components/Api/GeneratedDTOs/Commands/AddressSuggestionsCommand";

/** The zip-code / state lookup spry's address widget calls when a zip code loses focus. Built once
 * per app context so components take a plain function rather than knowing about the command. */
export function buildAddressSuggestionFetcher(apiClient: ApiClient): FetchesAddressSuggestions {
  return (zipCode, state) => apiClient.send(AddressSuggestionsCommand.load({ zipCode, state }));
}
